/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadyitememail3Inputs */

const en_searchreadyitememail3 = /** @type {(inputs: Searchreadyitememail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail address`)
};

const de_searchreadyitememail3 = /** @type {(inputs: Searchreadyitememail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

/**
* | output |
* | --- |
* | "E-mail address" |
*
* @param {Searchreadyitememail3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadyitememail3 = /** @type {((inputs?: Searchreadyitememail3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadyitememail3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadyitememail3(inputs)
	return de_searchreadyitememail3(inputs)
});
export { searchreadyitememail3 as "searchReadyItemEmail" }